import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoTigre = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Tigre - Predicciones Diarias | Midstino</title>
        <meta name="description" content="Horóscopo chino del signo Tigre. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Tigre." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="tigre" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Tigre</h1>
              <p className="text-muted-foreground">Años: 1926, 1938, 1950, 1962, 1974, 1986, 1998, 2010, 2022</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu pasión natural estará en su punto máximo hoy, Tigre. Tu carisma magnético atraerá admiradores. Las parejas vivirán momentos intensos y emocionantes llenos de aventura.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu valentía y liderazgo natural brillarán hoy. Es momento de tomar iniciativas audaces. Tu confianza inspirará a tu equipo y atraerá oportunidades importantes.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía vital está alta. Canaliza esta fuerza en actividades físicas que disfrutes. Deportes de aventura o ejercicios intensos te ayudarán a mantener tu equilibrio.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será perfecto para sorprender a tu pareja con gestos románticos espontáneos. Los solteros podrían vivir un encuentro apasionado e inesperado que cambie su perspectiva.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Nuevos desafíos se presentarán y estarás más que preparado para enfrentarlos. Tu instinto competitivo te llevará a destacar. Confía en tu capacidad de improvisación.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu vitalidad estará excelente. Aprovecha para actividades al aire libre o deportes que te desafíen físicamente. Tu cuerpo responderá positivamente al ejercicio intenso.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana electrizante en el amor. Tu magnetismo natural atraerá situaciones románticas emocionantes. Las parejas explorarán nuevas dimensiones de su relación con valentía.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana serás imparable. Tu coraje y determinación te llevarán a logros significativos. Oportunidades de liderazgo se presentarán. Toma el control con confianza.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía será abundante, pero cuidado con el exceso. Equilibra tu intensidad natural con momentos de descanso. La meditación activa podría beneficiarte.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoTigre;
